
import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/modules/RegistrationSetup.module.css';
import { TextField } from '@mui/material';
import { useLocation } from 'react-router';
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI';
import Loader from '../../../../component/Loader';
import { useSelector } from 'react-redux';
import { Privileges } from '../../../../util/PrivilegeConstants';
import { PrivilegeAPI } from '../../../../api/PrivilegesAPI';
import { getComponentByIndex, getIconByIndex, listOfOptions } from './HelperComponents';
import { isClubOwner } from '../../../../util/UserRoles';


const FormSettings = () => {
    const { state } = useLocation();
    const userInfo = useSelector((store) => store.user.userInfo);
    const [activeTab, setActiveTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [templateData, setTemplateData] = useState({ id: '', name: '', status: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [privileges, setPrivileges] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);


    const getFormTemplateName = async () => {
        try {
            const response = await FormTemplateAPI.getFormTemplateName(state.formTemplateId)
            setTemplateData(response.Data)
        } catch (error) {
            console.log(error);
        }
    };
    const editFormTemplateName = async () => {
        try {
            setIsLoading(true)
            await FormTemplateAPI.putUpdateFormTemplateName(templateData);
            setIsEdit(false);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const findAllPrivileges = async () => {
        try {
            setIsLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[11]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId])
    useEffect(() => {
        getFormTemplateName();
        isUpdate && setIsUpdate(false);
    }, [isUpdate])


    return (
        <div className={styles['form_setting']}>
            {isLoading && <Loader />}
            <div className={styles['form_setting_tab']}>
                {listOfOptions?.map((option, index) =>
                    <div key={index}
                        onClick={() => setActiveTab(index)}
                        className={activeTab === index
                            ? `${styles['form_setting_tab_body']} ${styles['active']}`
                            : styles['form_setting_tab_body']}>

                        <p>
                            {
                                getIconByIndex(index, activeTab)
                            }
                            <span>{option}</span>
                        </p>
                    </div>)}
            </div>
            {activeTab == 0 &&
                <>
                    <div className={styles['form_setting_template_name']}>
                        <TextField className={styles['form_text_field_theme']} disabled={!isEdit} value={templateData.name} onChange={(e) => setTemplateData({ ...templateData, name: e.target.value })} fullWidth size='small' label="Form Template Name" />
                        {(templateData.status === 'IN_PROGRESS'||isClubOwner(userInfo)) &&
                            <>
                                {isEdit ?
                                    <button onClick={editFormTemplateName}>Save</button>
                                    :
                                    <button onClick={() => setIsEdit(true)}>Edit</button>}
                            </>}
                    </div>
                </>}

            <div>
                {
                    getComponentByIndex(activeTab, state.formTemplateId, privileges, templateData.status, setIsUpdate)
                }
            </div>
        </div>
    )
}

export default FormSettings
